import { render, staticRenderFns } from "./AddModal.vue?vue&type=template&id=3f98c31d"
import script from "./AddModal.vue?vue&type=script&lang=js"
export * from "./AddModal.vue?vue&type=script&lang=js"
import style0 from "./AddModal.vue?vue&type=style&index=0&id=3f98c31d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports